module.exports = __webpack_public_path__ + "img/theme-c.e1a032c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/theme-c.png
// module id = 7bGu
// module chunks = 1